import {FormatNumberOptions, useIntl} from 'react-intl';
import {formatCurrency} from 'src/i18n/helpers/formatCurrency';

type FormatOptionsType = FormatNumberOptions;

export function useGlobalize() {
  const intl = useIntl();

  return {
    formatNumber: (value: number, options?: FormatOptionsType) =>
      intl.formatNumber(value, options),
    formatCurrency: (
      value: number | string,
      currency: string,
      options?: FormatOptionsType,
    ) => {
      return formatCurrency(intl, value, currency, options);
    },
  };
}

